export interface GroupSubmissionInput {
  email?: string;
  groupName: string;
  seatCount: number | null;
  minimumQuantity: number;
  isInternalCheckout: boolean;
  hasStripeSession: boolean;
  hasElements: boolean;
  hasSelectedGroupPrice: boolean;
  messages: {
    missingEmail: string;
    missingGroupName: string;
    belowMinimumSeats: string;
    stripeNotReady: string;
    selectPrice: string;
  };
}

export type GroupSubmissionValidation = { ok: true } | { ok: false; message: string };

export const validateGroupSubmission = (input: GroupSubmissionInput): GroupSubmissionValidation => {
  if (!input.email) {
    return { ok: false, message: input.messages.missingEmail };
  }

  if (!input.groupName.trim()) {
    return { ok: false, message: input.messages.missingGroupName };
  }

  if (input.seatCount === null || input.seatCount < input.minimumQuantity) {
    return { ok: false, message: input.messages.belowMinimumSeats };
  }

  if (input.isInternalCheckout && (!input.hasStripeSession || !input.hasElements)) {
    return { ok: false, message: input.messages.stripeNotReady };
  }

  if (!input.hasSelectedGroupPrice) {
    return { ok: false, message: input.messages.selectPrice };
  }

  return { ok: true };
};
